<div class="modal fade" id="commissionModal" tabindex="-1" role="dialog" aria-labelledby="commissionModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="form-group">
          <label for="commissionInput">Commission</label>
          <input type="number" class="form-control" id="commissionInput" placeholder="Enter commission rate"
            [formControl]='commissionFormControl'>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" #closebutton data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-success" (click)='updateCommission.emit(commissionFormControl.value)'
          data-dismiss="modal">Update</button>
      </div>
    </div>
  </div>
</div>